import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";

import { OrderList } from "../../models/order-list.model";
import { OrderDetail } from "../../models/order-detail.model";

@Injectable()
export class OrderProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  postDeliveryOrder(orderDatas: Object): Observable<boolean> {
    let headersConfig = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http
      .post<boolean>(`${this.url}/orders/delivery`, orderDatas, {
        headers: headersConfig
      }).catch(this.handleError);
  }
  
  postEditOrder(orderInfos: Object): Observable<boolean> {
    let headersConfig = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http
      .post<boolean>(`${this.url}/orders/edit`, orderInfos, {
        headers: headersConfig
      }).catch(this.handleError);
  }
  
  postEmailOrder(orderDatas: Object): Observable<boolean> {
    let headersConfig = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    
    return this.http
    .post<boolean>(`${this.url}/orders/print`, orderDatas, {
      headers: headersConfig
    }).catch(this.handleError);
  }

  sendPurchase(orderId): Observable<boolean> {
    return this.http
      .get<OrderDetail>(`${this.url}/orders/send-purchase/${orderId}`)
      .catch(this.handleError);
  }

  getOrderList(): Observable<OrderList[]> {
    return this.http
      .get<OrderList[]>(`${this.url}/orders/list`)
      .map(response => {
        return response.map((order) => {
          let orderInstance = new OrderList(order);
          return orderInstance;
        });
      })
      .catch(this.handleError);
  }

  getOrderDetail(orderId: number): Observable<OrderDetail> {
    return this.http
      .get<OrderDetail>(`${this.url}/orders/detail/${orderId}`)
      .map(response => {
        let orderInstance = new OrderDetail(response);
        return orderInstance;
      })
      .catch(this.handleError);
  }

  notificationOff(orderId: number): Observable<boolean> {
    return this.http
      .get<OrderDetail>(`${this.url}/orders/notification-off/${orderId}`)
      .catch(this.handleError);
  }

  cancelOrder(orderId: number): Observable<boolean> {
    return this.http
      .get<OrderDetail>(`${this.url}/orders/cancel/${orderId}`)
      .catch(this.handleError);
  }

  receivedOrder(orderId: number): Observable<boolean> {
    return this.http
      .get<OrderDetail>(`${this.url}/orders/received/${orderId}`)
      .catch(this.handleError);
  }
  
}



// WEBPACK FOOTER //
// ./src/providers/order/order.ts